<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div v-if="!showDocView" class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char20">
                <label class="label-caption">Tipo de Planilha</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>

            <div class="form-item-char15"><MesSelect v-model:opcaoSelecionada="mesSelecionado" /></div>

            <div class="form-item-char10">
                <label class="label-caption">Ano</label>
                <select v-model="anoSelecionado">
                    <option v-for="opcao in lsAnos" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="detalhamento">Justificativa</label>
                <textarea v-model="edJustificativa" id="detalhamento" maxlength="1000" rows="5" style="resize: none;"/>
            </div>
        </div>


        <div class="row-end">
            <button class="btn-confirm" @click="gerarDocAnulacao">Assinar e Protocolar</button>
            <button @click="closePage">Sair</button>
        </div>
    </div>


    <SenhaModal ref="senhaModalRef" />


    <div v-if="showDocView">
        <DocAnulacaoViewPage :idView="idDocView" @close="closePage" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarAssinatura } from '@/models/assinatura';
import { criarDocAnulacao } from '@/models/docAnulacao';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import DocAnulacaoViewPage from '../visualizacoes/DocAnulacaoViewPage.vue';
import MesSelect from '@/selects/estaticos/MesSelect.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';

const emit = defineEmits(['close']);
const senhaModalRef = ref(null);

const edJustificativa = ref(null);
const idDocView = ref(null);
const isLoading = ref(false);
const mesSelecionado = ref(0);
const msgAlerta = ref(null);
const objAssinatura = ref(criarAssinatura());
const objDocAnulacao = ref(criarDocAnulacao());
const objRef = ref({});
const showDocView = ref(false);

const lsAnos = ref([
    {id: 2024,    descricao: '2024'},
    {id: 2025,    descricao: '2025'},
    {id: 2026,    descricao: '2026'},
]);
const anoSelecionado = ref(2026)


const lsOpcoes = ref([
    {id: 'PLAEXPEDICAO',    descricao: 'EXPEDIÇÃO'},
    {id: 'PLALEITE',        descricao: 'LEITE'},
    {id: 'PLAMP',           descricao: 'MATÉRIA PRIMA'},
    {id: 'PLAMEL',          descricao: 'MEL'},
    {id: 'PLAPRODUCAO',     descricao: 'PRODUÇÃO'},
])
const opcaoSelecionada = ref('PLAEXPEDICAO')


const closePage = () => {emit('close');}


async function gerarDocAnulacao(){
    const r = Validar.texto(edJustificativa.value, 'Informe a justificativa');
    if (!r.ok){msgAlerta.value = r.msg; return;}

    try{
        msgAlerta.value = null;
        if ((!anoSelecionado.value) || (!mesSelecionado.value)) throw new Error('Informe o período corretamente');

        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;

        isLoading.value = true;

        
        // 1- OBTER OBJETO REFERÊNCIA
        const req = await Api.genericPost('/doc/docanulacao/getref', {
            idep: globalStore.idep,
            idestabelecimento: globalStore.idestabelecimento,
            intparam1: (anoSelecionado.value * 100) + (mesSelecionado.value),
            strparam1: opcaoSelecionada.value});
        if (!req || req.length === 0) throw new Error('Planilha de referência não localizada');
        Object.assign(objRef.value, req[0]);

        
        // 2- REGISTRAR ASSINATURA
        objAssinatura.value.idep            = globalStore.idep;
        objAssinatura.value.idusuario       = globalStore.idusuario;
        objAssinatura.value.idsessao        = globalStore.idlogin;
        objAssinatura.value.nmusuario       = globalStore.nmusuario;
        objAssinatura.value.vssistema       = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.value.ass_conteudo    = `REF:${objRef.value.reftable}|IDREF:${objRef.value.refid}|PROT:${objRef.value.refprotocolo}`;
        objAssinatura.value.ass_senha       = senhaDigitada;
        objAssinatura.value.ass_tipoauth    = 'senha pessoal via sistema WEB';
        objAssinatura.value.doc_idorigem    = objRef.value.refid;
        objAssinatura.value.doc_tipo        = objRef.value.reftable;
        const respAss = await Api.genericPut('/doc/assinar', objAssinatura.value);
        if (respAss.bolok != 1) throw new Error(`ATENÇÃO: ${respAss.erro}`);
        

        // 3- REGISTRAR DOCANULACAO

        objDocAnulacao.value.idep                   = globalStore.idep;
        objDocAnulacao.value.idsim                  = globalStore.idsim;
        objDocAnulacao.value.idestabelecimento      = globalStore.idestabelecimento;
        objDocAnulacao.value.cdperfil               = 1;
        objDocAnulacao.value.dtregistro             = Funcoes.strDataAtual;
        objDocAnulacao.value.idprotocolo            = respAss.id;
        objDocAnulacao.value.informacoes            = edJustificativa.value;
        objDocAnulacao.value.refid                  = objRef.value.refid;
        objDocAnulacao.value.reftabela              = objRef.value.reftable;
        objDocAnulacao.value.refidentificacao       = objRef.value.refidentificacao;
        objDocAnulacao.value.refdtperiodo           = objRef.value.refdtperiodo;
        objDocAnulacao.value.refprotocolo           = objRef.value.refprotocolo;
        objDocAnulacao.value.idlogin                = globalStore.idlogin;
        objDocAnulacao.value.idusuario              = globalStore.idusuario;
        const respDoc = await Api.genericPut('/doc/docanulacao', objDocAnulacao.value);
        if (respDoc.bolok != 1) throw new Error(`ATENÇÃO: ${respDoc.erro}`);

        // 4- EXECUTAR ROTINA DE ENCERRAMENTO
        const respExec = await Api.genericPost('/doc/exec_requisicao', {
            id: respDoc.id,
            idep: globalStore.idep,
            nmrequisicao: 'SPDOCANULACAO_PROTOCOLAR',
            idusuario: globalStore.idusuario,
            idlogin: globalStore.idlogin});

        if (respExec.bolok==1){
            idDocView.value = respDoc.id;
            showDocView.value = true;
        }else{throw new Error(respExec.erro)}


    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}
</script>